import { useMemo } from 'react';
import { Badge } from 'react-bootstrap';
import { EventRequestStatus } from 'src/typings/api-models.generated';

interface Props {
    status: EventRequestStatus;
    className?: string;
}

export const EventRequestStatusBadge = ({ status, className }: Props): React.ReactElement => {
    const badgeClass = useMemo(() => {
        switch (status) {
            case 'Draft':
            case 'Pending':
                return 'outline-info';
            case 'Approved':
                return 'outline-success';
            case 'Rejected':
                return 'outline-danger';
            default:
                return 'outline-secondary';
        }
    }, [status]);

    return (
        <Badge variant={badgeClass} className={`font-weight-normal ${className || ''}`}>
            {status}
        </Badge>
    );
};
